module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_c('data-table', {
    attrs: {
      "table-ref": "site-contractors-table",
      "title": "Contractors Statement",
      "url": '/contractor/site/' + _vm.siteId,
      "hide-org-badge": "",
      "sort-field": "started",
      "fields": _vm.fields,
      "add-action": _vm.action,
      "add-props": _vm.addPropsData,
      "detail-component": "site-contractors-detail-row"
    },
    scopedSlots: _vm._u([{
      key: "admin-action",
      fn: function(props) {
        return [(_vm.isSuper() || _vm.isManager('finance')) ? _c('el-button', {
          staticClass: "hidden-md-and-down",
          attrs: {
            "type": "danger",
            "size": "mini",
            "icon": "fa fa-trash-alt",
            "circle": ""
          },
          on: {
            "click": function($event) {
              return _vm.deleteRow(props.rowData)
            }
          }
        }) : _vm._e()]
      }
    }])
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ce88d49"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sites/finance/contractors/SiteContractorsTable.vue
// module id = 1589
// module chunks = 0